
import { OrderStatus, UserRole, AppVertical } from './types';

// Visual configuration for order status badges
export const STATUS_COLORS: Record<OrderStatus, string> = {
  [OrderStatus.PENDENTE]: 'bg-gray-100 text-gray-700 border-gray-200',
  [OrderStatus.AGUARDANDO_FINANCEIRO]: 'bg-amber-50 text-amber-700 border-amber-200',
  [OrderStatus.CONFIRMADO]: 'bg-green-100 text-green-700 border-green-200',
  [OrderStatus.EM_CARREGAMENTO]: 'bg-blue-50 text-blue-600 border-blue-100',
  [OrderStatus.EM_ROTA]: 'bg-indigo-50 text-indigo-600 border-indigo-100',
  [OrderStatus.MONTAGEM]: 'bg-purple-50 text-purple-600 border-purple-100',
  [OrderStatus.PROBLEMA]: 'bg-red-100 text-red-700 border-red-200',
  [OrderStatus.CONCLUIDO]: 'bg-blue-100 text-blue-700 border-blue-200',
  [OrderStatus.CANCELADO]: 'bg-slate-100 text-slate-700 border-slate-200',
};

// Indicator dots used in reports and dashboards
export const STATUS_DOTS: Record<OrderStatus, string> = {
  [OrderStatus.PENDENTE]: 'bg-gray-500',
  [OrderStatus.AGUARDANDO_FINANCEIRO]: 'bg-amber-500',
  [OrderStatus.CONFIRMADO]: 'bg-green-500',
  [OrderStatus.EM_CARREGAMENTO]: 'bg-blue-400',
  [OrderStatus.EM_ROTA]: 'bg-indigo-500',
  [OrderStatus.MONTAGEM]: 'bg-purple-500',
  [OrderStatus.PROBLEMA]: 'bg-red-500',
  [OrderStatus.CONCLUIDO]: 'bg-blue-500',
  [OrderStatus.CANCELADO]: 'bg-slate-500',
};

export const POLICY_TEXT = `Para garantir a pontualidade da operação, é obrigatório que haja um responsável no local no dia e horário agendados para entrega/montagem/retirada. Caso não haja responsável e a equipe seja impedida de executar o serviço no horário combinado, poderá ser cobrada taxa de deslocamento adicional.`;

export const ROLE_LABELS = {
  [UserRole.SUPER_ADMIN]: 'Administrador Master',
  [UserRole.ADMIN]: 'Administrador',
  [UserRole.COMERCIAL]: 'Comercial',
  [UserRole.LOGISTICA]: 'Logística',
  [UserRole.MONTAGEM]: 'Equipe Externa',
  [UserRole.FINANCEIRO]: 'Financeiro',
  [UserRole.OPERACIONAL]: 'Montagem',
};

/**
 * Sistema de Labels Dinâmicos baseado na Vertical Ativa
 * Isso permite que o sistema mude de "Eventos" para "Construção" instantaneamente
 */
export const getVerticalLabels = (vertical: AppVertical) => {
  const dictionary = {
    [AppVertical.EVENTS]: {
      order: 'Evento',
      orders: 'Eventos',
      action: 'Montagem',
      teams: 'Equipes de Montagem',
      client: 'Produtora/Cliente',
      location: 'Local do Evento'
    },
    [AppVertical.CONSTRUCTION]: {
      order: 'Obra',
      orders: 'Obras/Projetos',
      action: 'Instalação Técnica',
      teams: 'Equipes de Campo',
      client: 'Construtora/Engenheiro',
      location: 'Canteiro de Obras'
    },
    [AppVertical.MEDICAL]: {
      order: 'Paciente',
      orders: 'Atendimentos HomeCare',
      action: 'Entrega Médica',
      teams: 'Técnicos de Saúde',
      client: 'Hospital/Convênio',
      location: 'Residência do Paciente'
    },
    [AppVertical.RETAIL]: {
      order: 'Entrega',
      orders: 'Pedidos Last Mile',
      action: 'Despacho',
      teams: 'Entregadores',
      client: 'Consumidor Final',
      location: 'Ponto de Entrega'
    }
  };

  return dictionary[vertical] || dictionary[AppVertical.EVENTS];
};
